import { lazy, Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftRight } from 'lucide-react';
import type { MovableLog } from './moveLogsModel';

const MoveLogsDialog = lazy(() => import('./MoveLogsDialog'));

/** D-348 - the "העברת לוגים להתקשרות אחרת" button + its dialog (log detail, task card, log edit). */
export default function MoveLogsButton({ logs, onMoved, className = 'btn btn-secondary btn-sm', testId = 'move-logs-button' }: {
  logs: MovableLog[];
  onMoved?: () => void;
  className?: string;
  testId?: string;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  if (logs.length === 0) return null;
  return (
    <>
      <button type="button" className={className} onClick={() => setOpen(true)} data-testid={testId}>
        <ArrowLeftRight size={14} aria-hidden="true" /> {t('moveLogs.button')}
        {logs.length > 1 && <span className="tabular-nums">({logs.length})</span>}
      </button>
      {open && (
        <Suspense fallback={null}>
          <MoveLogsDialog open={open} onClose={() => setOpen(false)} logs={logs} onMoved={onMoved} />
        </Suspense>
      )}
    </>
  );
}
